var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserFriendsSolid = function SvgUserFriendsSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C9.93437 12 11.5 10.4344 11.5 8.5C11.5 6.56562 9.93437 5 8 5C6.06563 5 4.5 6.56562 4.5 8.5C4.5 10.4344 6.06563 12 8 12ZM10.4 13H10.1406C9.49062 13.3125 8.76875 13.5 8 13.5C7.23125 13.5 6.5125 13.3125 5.85938 13H5.6C3.6125 13 2 14.6125 2 16.6V17.5C2 18.3281 2.67188 19 3.5 19H12.5C13.3281 19 14 18.3281 14 17.5V16.6C14 14.6125 12.3875 13 10.4 13ZM17 12C18.6562 12 20 10.6562 20 9C20 7.34375 18.6562 6 17 6C15.3438 6 14 7.34375 14 9C14 10.6562 15.3438 12 17 12ZM18.5 13H18.3813C17.9469 13.15 17.4875 13.25 17 13.25C16.5125 13.25 16.0531 13.15 15.6187 13H15.5C14.8625 13 14.275 13.1844 13.7594 13.4812C14.5219 14.3031 15 15.3938 15 16.6V17.8C15 17.8688 14.9844 17.9344 14.9812 18H20.5C21.3281 18 22 17.3281 22 16.5C22 14.5656 20.4344 13 18.5 13Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserFriendsSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_friends_solid.331773cc.svg";
export { ForwardRef as ReactComponent };